import { createSelector } from 'reselect';

export const getNewFeaturesDraftSelector = (state, parentId) =>
  state.draft.getIn(['newFeaturesDraft', String(parentId)]);

export const getNewFeaturesDraft = createSelector(
  getNewFeaturesDraftSelector,
  draft => draft,
);
